import { useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { enviroment } from '@utils/config';

function useTheme() {

  const clientTarget = useSelector(({ user }) => user.clientTarget);

  const defaultTemplate = useMemo(() => {

    const celsiaDefault = {
      icon: `${process.env.PUBLIC_URL}/favicon.ico`,
      platform_title: 'Celsia - IotBox',
      primary_color: '#ff812e',
      secundary_color: '#49a2d8',
    };

    const mubonDefault = {
      icon: `${process.env.PUBLIC_URL}/favicon_mubon.ico`,
      platform_title: 'Mubon - Retail y Almacenamiento',
      primary_color: '#376680',
      secundary_color: '#376680',
    };

    return enviroment.platform === 'mubon' ? mubonDefault : celsiaDefault;

  }, []);

  useEffect(() => {

    const { properties: tempProperties } = clientTarget || {};
    const properties = tempProperties || defaultTemplate;

    const {
      platform_title, icon, primary_color, secundary_color,
    } = properties || {};

    // Set platform name
    if (platform_title) {

      document.title = platform_title;

    }

    // Set favicon
    if (icon) {

      document.querySelector("link[rel*='icon']").href = icon;

    }

    try {

      // Set colors
      window.less.modifyVars({
        '@primary-color': primary_color,
        '@secundary-color': secundary_color,
      });
      window.less.refreshStyles();

    } catch (error) {

      console.log('error: ', error);

    }

  }, [clientTarget, defaultTemplate]);

}

export default useTheme;
